import MasterApi from './MasterApi';

export default class SensorType extends MasterApi {
  constructor() {
    super();
    this.masterName = 'sensor_type';
  }
}
